'use strict';

function fixViewportTag(siteData, params) {
  var viewport = typeof document !== 'undefined' && window.document.getElementById('wixMobileViewport');

  if (!viewport) {
    return;
  }

  var browserFlags = siteData.browserFlags();
  var responsive = params && params.isResponsive;
  var width = responsive ? 'device-width' : siteData.getSiteWidth();
  var userScalable = responsive && browserFlags.forceOverflowScroll ? 'no' : 'yes';

  var finalizeViewport = function finalizeViewport() {
    return viewport.setAttribute('content', "width=" + width + ", user-scalable=" + userScalable);
  };

  if (responsive || !browserFlags.doubleResetMobileViewport) {
    finalizeViewport();
    return;
  }

  viewport.setAttribute('content', "width=" + width + ", user-scalable=yes, initial-scale=0");
  return window.requestAnimationFrame(function () {
    viewport.setAttribute('content', "width=" + width + ", user-scalable=yes, initial-scale=" + window.screen.width / width);
    return window.requestAnimationFrame(finalizeViewport);
  });
}

module.exports = {
  fixViewportTag: fixViewportTag
};
//# sourceMappingURL=mobileViewportFixer.js.map